import React from "react";
import PropTypes from "prop-types";
import { DynamicField as DFH } from "@heartfulnessinstitute/react-hfn-forms/dist/DynamicForm";

const Select = ({
  name,
  label,
  value,
  options,
  onChange,
  renderPrint,
  ...restProps
}) => {
  const myOptions = options;

  React.useEffect(() => {
    if (options?.length === 1 && !value) {
      const onlyOption = options[0];
      if (!onlyOption.disabled && onChange) {
        onChange(onlyOption.name, onlyOption);
      }
    }
  }, [options, value, onChange]);
  if (renderPrint) {
    const option = options.find((o) => o.name === value);
    return renderPrint(option ? option.label : value);
  }

  const handleChange = (event) => {
    const selectedValue = event || "";
    const selectedOption = options?.find((o) => o.name === selectedValue);

    if (selectedOption?.disabled) {
      return;
    }

    const objId = selectedOption?.name || selectedValue;
    const objValue = selectedOption || { label: selectedValue };
    if (onChange) {
      onChange(objId, objValue);
    }
  };

  return (
    <DFH
      type="select"
      name={name}
      label={label}
      value={value}
      onChange={handleChange}
      options={myOptions || []}
      props={{ ...restProps, required: false }}
    />
  );
};

Select.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renderPrint: PropTypes.func,
};

Select.defaultProps = {
  onChange: null,
  value: "",
  renderPrint: null,
  label: "",
};

export default React.memo(Select);
